/**
 * @generated SignedSource<<22be4551e78477ef1e8a7cb8f44dd241>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AccountType = "ProductLed" | "SalesLed";
export type SetAccountTypeAndDomainInput = {
  accountType: AccountType;
  clientMutationId?: string | null;
  domain?: string | null;
  id: string;
};
export type editLeadStrategyForm_SetAccountTypeMutation$variables = {
  input: SetAccountTypeAndDomainInput;
};
export type editLeadStrategyForm_SetAccountTypeMutation$data = {
  readonly Admin: {
    readonly Auth: {
      readonly setAccountTypeAndDomain: {
        readonly account: {
          readonly id: string;
        };
      } | null;
    };
  };
};
export type editLeadStrategyForm_SetAccountTypeMutation = {
  response: editLeadStrategyForm_SetAccountTypeMutation$data;
  variables: editLeadStrategyForm_SetAccountTypeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthAdminMutationSchema",
        "kind": "LinkedField",
        "name": "Auth",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "SetAccountTypeAndDomainPayload",
            "kind": "LinkedField",
            "name": "setAccountTypeAndDomain",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Account",
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "editLeadStrategyForm_SetAccountTypeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "editLeadStrategyForm_SetAccountTypeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "860be1484e713fee2cf0c14d63e1633a",
    "id": null,
    "metadata": {},
    "name": "editLeadStrategyForm_SetAccountTypeMutation",
    "operationKind": "mutation",
    "text": "mutation editLeadStrategyForm_SetAccountTypeMutation(\n  $input: SetAccountTypeAndDomainInput!\n) {\n  Admin {\n    Auth {\n      setAccountTypeAndDomain(input: $input) {\n        account {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9d4fbfee4ef1338a79c926da1f2dad7d";

export default node;
